// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"65827944","163":"0fc621c0","453":"19c54b10"}[chunkId] + ".chunk.js";
};